import { AuthForm } from "@-/dev.improve.haniverse.components.ui.auth-form";
import * as React from "react";

export type SignUpFormProps = {
  /** Only the fields, for the auth sheet; see `AuthFormProps.bare`. */
  bare?: boolean;
  /** Disables the inputs and primary button while an auth request is in flight. */
  busy?: boolean;
  card?: boolean;
  compact?: boolean;
  /** Controlled email value; falls back to internal uncontrolled state when omitted. */
  email?: string;
  onChangeEmail?: (value: string) => void;
  onChangePassword?: (value: string) => void;
  onNavigateSignIn?: () => void;
  /** Submit handler. Receives the current field values. */
  onSubmit?: (values: { email: string; password: string }) => void;
  /** Controlled password value; falls back to internal uncontrolled state when omitted. */
  password?: string;
  /**
   * Optional social sign-in controls (e.g. Apple / Google buttons). Omit or pass
   * `null` to hide social sign-in entirely.
   */
  socialConnections?: React.ReactNode;
  /** Replaces the primary button label while email/password sign-up is pending. */
  submitPendingLabel?: string;
};

export function SignUpForm({
  bare = false,
  busy = false,
  card = false,
  compact = false,
  email,
  onChangeEmail,
  onChangePassword,
  onNavigateSignIn,
  onSubmit,
  password,
  socialConnections,
  submitPendingLabel,
}: SignUpFormProps = {}) {
  return (
    <AuthForm
      bare={bare}
      busy={busy}
      card={card}
      compact={compact}
      contentClassName="gap-5"
      description={
        card
          ? "Start learning Chinese, one character at a time."
          : compact
            ? "Start learning Chinese with Han."
            : "Learn characters. Remember more. Open up a new world."
      }
      email={email}
      footerLinkLabel="Sign in"
      footerPrompt="Already have an account?"
      onChangeEmail={onChangeEmail}
      onChangePassword={onChangePassword}
      onNavigate={onNavigateSignIn}
      onSubmit={onSubmit}
      password={password}
      slogan="Master Chinese, fast."
      socialConnections={socialConnections}
      submitLabel={compact || bare || card ? "Create account" : undefined}
      submitPendingLabel={submitPendingLabel}
      title="Create your account"
    />
  );
}
